import { get } from "./index";

export const getAirprtsList = (params) => {
  const request = {
    subUrl: `/website/v2/getAllAirports`,
    params,
  };
  return get(request);
};